module.exports = __webpack_public_path__ + "img/kitchen_01.4959e19b.png";